import type { ReactNode } from 'react';

import ArrowLeftIcon from '@heroicons/react/24/outline/ArrowLeftIcon';
import { Button, Text } from 'atp-react-ui';
import { Link, type To } from 'react-router';

import type { BreadcrumbPage } from '@/_components/page-heads';
import BreadCrumbs from '@/_components/page-heads/bread-crumbs';

import Container from './container';
import PageHead from './page-head';
import { StickyPageHeader } from './sticky-header';

type StickyHeaderWithBreadcrumbsProps = {
  title: string;
  pages: BreadcrumbPage[];
  className?: string;
  onBack?: () => void;
  backLink?: To;
  children?: ReactNode;
};

export function StickyHeaderWithBreadcrumbs({
  title,
  pages,
  className,
  backLink,
  onBack,
  children,
}: StickyHeaderWithBreadcrumbsProps) {
  return (
    <StickyPageHeader className={className}>
      <Container>
        <PageHead className="flex-col items-start">
          <BreadCrumbs pages={pages} />
          <section className="mt-2 flex items-center">
            {backLink ? (
              <Link to={backLink}>
                <Button icon={ArrowLeftIcon} size="sm" as="link" className="mr-4" />
              </Link>
            ) : (
              <Button icon={ArrowLeftIcon} onClick={onBack} size="sm" as="link" className="mr-4" />
            )}
            <Text as="h1">{title}</Text>
          </section>
          {children}
        </PageHead>
      </Container>
    </StickyPageHeader>
  );
}
